<template>
    <div class="header-short">
        <div class="background" />
        <div class="solutions-container">
            <slot name="top-nav" />
            <div class="header-inner">
                <h1 class="title">
                    {{ title }}
                </h1>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SolutionsHeaderShort',
    props: {
        title: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="postcss" scoped>
.header-short {
    position: relative;
    color: var(--av-inversed-primary);
    background: var(--av-nav-primary);
}

.background {
    position: absolute;
    inset: 0;
    overflow: hidden;

    &::after {
        position: absolute;
        content: '';
        display: block;
        border-radius: 1547px;
        background: radial-gradient(50% 50% at 50% 50%, #0065e3 0%, #00204d 100%);
        width: 1547px;
        height: 599px;
        inset-inline-start: -350px;
        bottom: -283px;

        @media (--viewport-mobile-wide) {
            bottom: -251px;
        }

        @media (--viewport-tablet) {
            inset-inline-start: auto;
            inset-inline-end: -465px;
            bottom: -299px;
        }

        @media (--viewport-desktop-wide) {
            bottom: -291px;
        }
    }
}

.header-inner {
    border-top: 1px solid var(--av-inversed-lighter);
    padding: 48px 0;
}

.title {
    @mixin display-accent;

    @media (--viewport-mobile-wide) {
        @mixin hero-accent;
    }

    @media (--viewport-desktop-wide) {
        @mixin large-accent;
    }
}
</style>
